<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M44 16.9994L44 22.791" :stroke="props.iconColor" stroke-width="1.6" stroke-linecap="round" />
		<path d="M44 32.9994L44 38.791" :stroke="props.iconColor" stroke-width="1.6" stroke-linecap="round" />
		<path d="M54.7916 28L49 28" :stroke="props.iconColor" stroke-width="1.6" stroke-linecap="round" />
		<path d="M38.7916 28L33 28" :stroke="props.iconColor" stroke-width="1.6" stroke-linecap="round" />
		<path d="M37.8467 32.7408L33.168 36.1543" :stroke="props.iconColor" stroke-width="1.6" stroke-linecap="round" />
		<path d="M26.7189 36.3565L21.9219 33.1113" :stroke="props.iconColor" stroke-width="1.6" stroke-linecap="round" />
		<path d="M16.0953 34.0004L12 38.0957" :stroke="props.iconColor" stroke-width="1.6" stroke-linecap="round" />
		<path
			d="M18.9502 34.1563C17.1974 34.1563 15.7734 32.7323 15.7734 30.9795C15.7734 29.2267 17.1974 27.8027 18.9502 27.8027C20.703 27.8027 22.127 29.2267 22.127 30.9795C22.127 32.7323 20.703 34.1563 18.9502 34.1563Z"
			:stroke="props.iconColor"
			stroke-width="1.6"
		/>
		<path
			d="M9.17677 43.9317C7.42394 43.9317 6 42.5077 6 40.7549C6 39.0021 7.42394 37.5781 9.17677 37.5781C10.9296 37.5781 12.3535 39.0021 12.3535 40.7549C12.3535 42.5077 10.9296 43.9317 9.17677 43.9317Z"
			:stroke="props.iconColor"
			stroke-width="1.6"
		/>
		<path
			d="M29.9463 41.4883C28.1935 41.4883 26.7695 40.0644 26.7695 38.3115C26.7695 36.5587 28.1935 35.1348 29.9463 35.1348C31.6991 35.1348 33.1231 36.5587 33.1231 38.3115C33.1231 40.0644 31.6991 41.4883 29.9463 41.4883Z"
			:stroke="props.iconColor"
			stroke-width="1.6"
		/>
		<path
			d="M43.9419 35.8839C39.5598 35.8839 36 32.324 36 27.9419C36 23.5598 39.5598 20 43.9419 20C48.324 20 51.8839 23.5598 51.8839 27.9419C51.8839 32.324 48.324 35.8839 43.9419 35.8839Z"
			:stroke="props.iconColor"
			stroke-width="1.6"
		/>
	</svg>
</template>

<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 60,
		height: 60,
		iconColor: '#ffffff',
	}
);
</script>
<style lang="scss" scoped></style>
